import { NavIconChevronLeft, NavIconChevronRight } from "./NavIcons";

export function SidebarBoundaryToggle({
  isCollapsed,
  left,
  onClick,
}: {
  isCollapsed: boolean;
  left: number;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="sidebar-boundary-toggle"
      style={{ left, transition: "left 250ms ease-in-out" }}
      onClick={onClick}
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      {isCollapsed ? <NavIconChevronRight /> : <NavIconChevronLeft />}
    </button>
  );
}
